import { defineMessages, type MessageDescriptor } from "react-intl";

import { TAX_DETAILS_STATUS } from "../TaxDetails.consts";
import type { TaxDetailsStatus } from "../TaxDetails.types";

/** Pill copy per status. Statuses absent from this map render no pill. */
const TAX_DETAILS_STATUS_PILL_MESSAGES: Partial<
  Record<TaxDetailsStatus, MessageDescriptor>
> = defineMessages({
  [TAX_DETAILS_STATUS.pending]: {
    id: "tax_details.banner_pill.pending_status",
    defaultMessage: "Pending validation",
  },
  [TAX_DETAILS_STATUS.validated]: {
    id: "tax_details.banner_pill.validated_status",
    defaultMessage: "Validated",
  },
  [TAX_DETAILS_STATUS.invalid]: {
    id: "tax_details.banner_pill.invalid_status",
    defaultMessage: "Not valid on VIES",
  },
});

const TAX_DETAILS_BANNER_MESSAGES = defineMessages({
  addDetails: {
    id: "tax_details.tax_details_banner.add",
    defaultMessage: "Add",
  },
  updateDetails: {
    id: "tax_details.tax_details_banner.update",
    defaultMessage: "Update",
  },
  deleteDetails: {
    id: "tax_details.tax_details_banner.delete",
    defaultMessage: "Delete VAT details",
  },
  moreInformation: {
    id: "tax_details.tax_details_banner.more_information",
    defaultMessage: "More information",
  },
  close: {
    id: "tax_details.tax_details_banner.close",
    defaultMessage: "Close",
  },
});

export { TAX_DETAILS_BANNER_MESSAGES, TAX_DETAILS_STATUS_PILL_MESSAGES };
